import React, { PropsWithChildren, ReactElement } from 'react';

import './modal.scss';

interface ModalLayoutProps {
    title?: string;
}

const ModalLayout: React.FC<PropsWithChildren<ModalLayoutProps>> = ({ title, children }): ReactElement => (
    <div className="modal">
        <div className="modal__header">
            {title || (
                <>
                    &nbsp;
                </>
            )}
        </div>
        <div className="modal__content">
            {children}
        </div>
    </div>
);

export default ModalLayout;
